import { IReview } from '@backend/domain'
import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger'

export class Review implements IReview {
	@ApiProperty({ type: String })
	authorName: string

	@ApiProperty({ type: String })
	authorProfileImageUrl: string

	@ApiProperty({ type: Number })
	rating: number

	@ApiProperty({ type: String })
	text: string

	@ApiProperty({ type: Date })
	timestamp: Date
}

export class CustomerReviewsResponse {
	@ApiProperty({ type: Number })
	rating: number

	@ApiProperty({ type: Number })
	totalRatings: number

	@ApiPropertyOptional({ type: String })
	reviewUrl?: string
}

export class GoogleReview {
	@ApiProperty({ type: String })
	author_name: string

	@ApiProperty({ type: String })
	profile_photo_url: string

	@ApiProperty({ type: Number })
	rating: number

	@ApiProperty({ type: String })
	text: string

	@ApiProperty({ type: Number })
	time: number
}

export class GooglePlaceDetailsResponse {
	@ApiProperty({ type: Number })
	rating: number

	@ApiProperty({ type: Number })
	user_ratings_total: number

	@ApiProperty({ type: GoogleReview, isArray: true })
	reviews: GoogleReview[]
}
